import React from 'react';

const Loading = ({ type = 'button', showText = true, text, className = '' }) => {
  const isInline = type === 'button' || type === 'small';

  return (
    <div className={`rc-loading rc-loading--${type} ${className}`}>
      <div className="rc-loading__spinner" />
      {!isInline && (showText || text) && (
        <p className="rc-loading__text">{text || "Please wait while the data is loaded..."}</p>
      )}
    </div>
  );
};

export default Loading;
